import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.getCurrentUserValue;
        let islogged = localStorage.getItem('loggedIn');
        let accessmfa = localStorage.getItem('accessmfa');
        let mfastatus = localStorage.getItem('mfastatus');

        if (currentUser && currentUser.userName && currentUser.userName !== '' && mfastatus != null) {
            const redirectRoute = islogged === '1' && mfastatus === '1' ? 'dashboard' : (accessmfa === '0' && mfastatus === '0' ? 'twofactorsettings' : null);
            if (redirectRoute) {
                if (route.data.roles && route.data.roles.indexOf(currentUser.userType) === -1) {
                    this.router.navigate([redirectRoute]);
                    return false;
                }
            }
            // Authorized, allow access
            return true;
        }

        // Not logged in, redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}